import instamapsBreadcrumbs from '../shared/components/breadcrumbs/breadcrumbs.vue';
import bannerSlider from './components/banner-slider/banner-slider.vue';
import itemsSlider from './components/items-slider/items-slider.vue';
import instamapsNewsletterModal from './components/newsletter-modal/newsletter-modal.vue';
import instamapsInfoModal from './components/info-modal/info-modal.vue';
import instamapsInscripcioModal from './components/inscripcio-modal/inscripcio-modal.vue';
import messages from './home-geolocal-translations';
import { ApplicationConstants } from '../shared/applicationConstants';
import { HomeService } from './services/homeService';

export default {
    name: 'instamapHome',
    i18n: {
        messages,
    },
    components: {
        instamapsBreadcrumbs,
        bannerSlider,
        itemsSlider,
        instamapsNewsletterModal,
        instamapsInfoModal,
        instamapsInscripcioModal,
    },
    data: () => {
        return {
            mapa: ApplicationConstants.baseEditorUrl,
            homePreviewMaps: [],
        };
    },
    props: {
        selectedLang: { type: String },
        hasBreadcrumbs: { type: Boolean },
    },
    methods: {
        showNewsletterModal: function () {
            this.$emit('showNewsletterModal');
        },
        showInfoModal: function () {
            this.$emit('showInfoModal');
        },
        showInscripcioModal: function () {
            this.$emit('showInscripcioModal');
        },
    },
    mounted() {
        HomeService.getHomePreviewMaps().then((elements) => {
            this.homePreviewMaps = elements;
        });

        this.showNewsletterModal();
        this.showInfoModal();
        this.showInscripcioModal();
    },
};



// WEBPACK FOOTER //
// ./src/home-geolocal/home-geolocal.js